/* Keep the app-powered cart's shipping information aligned with the theme.
   The app owns cart calculations and checkout; this only adds a policy note. */
(() => {
  const template = document.getElementById('mimu-cart-shipping-template');
  if (!template) return;
  let scheduled = false;
  const sync = () => {
    scheduled = false;
    document.querySelectorAll('.ocu-cart-footer').forEach((footer) => {
      if (footer.querySelector('.mimu-shipping-guidance')) return;
      const checkout = footer.querySelector('.cart__ctas');
      if (checkout) checkout.before(template.content.cloneNode(true));
    });
  };
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  });
  observer.observe(document.body, { childList: true, subtree: true });
  sync();
})();

/* Keep the cart link usable if a drawer app intercepts it but fails to open.
   A working native or app drawer retains its existing behavior. */
(() => {
  let fallbackTimer;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('#cart-icon-bubble');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const cartUrl = link.getAttribute('href');
    if (!cartUrl) return;
    clearTimeout(fallbackTimer);
    fallbackTimer = setTimeout(() => {
      const openDrawer = Array.from(document.querySelectorAll('cart-drawer .drawer__inner, .ocu-cart-drawer')).some((drawer) => {
        const style = getComputedStyle(drawer);
        const box = drawer.getBoundingClientRect();
        return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0 &&
          box.width > 0 && box.height > 0 && box.left < innerWidth && box.right > 0;
      });
      if (!openDrawer) window.location.assign(cartUrl);
    }, 1200);
  }, true);
})();
